export default {
  title: 'Kurs for undervisere',
  language: 'nb-NO',
  showSub: true,
  completedLevels: 0,
  courseCompleted: false,
  courseMode: '', // Gjest || Innlogget || Kompetansepluss
  allowSkip: true,
  levels: [
    {
      id: 'l-1',
      bg: '#55AABB',
      completed: false,
      tasks: [{
        id: 'page-4',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-2',
      bg: '#7B396E',
      completed: false,
      tasks: [{
        id: 'page-3',
        completed: false
      }, {
        id: 'page-6',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-3',
      bg: '#575955',
      completed: false,
      tasks: [{
        id: 'page-5',
        completed: false
      }, {
        id: 'page-6',
        completed: false
      }, {
        id: 'page-7',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-4',
      bg: '#74766F',
      completed: false,
      tasks: [{
        id: 'page-8',
        completed: false
      }, {
        id: 'page-9',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-5',
      bg: '#C49A55',
      completed: false,
      tasks: [{
        id: 'page-6',
        completed: false
      }, {
        id: 'page-9',
        completed: false
      }, {
        id: 'page-10',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-6',
      bg: '#4F909C',
      completed: false,
      tasks: [{
        id: 'page-6',
        completed: false
      }, {
        id: 'page-9',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-7',
      bg: '#CA5B32',
      completed: false,
      tasks: [{
        id: 'page-6',
        completed: false
      }, {
        id: 'page-7',
        completed: false
      }, {
        id: 'page-10',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-8',
      bg: '#665192',
      completed: false,
      tasks: [{
        id: 'page-4',
        completed: false
      }, {
        id: 'page-5',
        completed: false
      }, {
        id: 'page-6',
        completed: false
      }],
      lastpage: 'page-1'
    },
    {
      id: 'l-9',
      bg: '#707A62',
      completed: false,
      tasks: [{
        id: 'page-4',
        completed: false
      }, {
        id: 'page-5',
        completed: false
      }, {
        id: 'page-6',
        completed: false
      }],
      lastpage: 'page-1'
    }
  ]
}
